import React from 'react';
import { Tooltip } from '@mui/material';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

interface FinancialTrustBadgeProps {
  tier?: number;
  size?: 'small' | 'medium';
}

const FinancialTrustBadge: React.FC<FinancialTrustBadgeProps> = ({ tier = 0, size = 'small' }) => {
  if (!tier || tier < 1) return null;

  const iconSize = size === 'small' ? 16 : 20;
  const tooltip =
    tier >= 3
      ? 'Sustained external card/ACH payments on the same account'
      : tier >= 2
        ? 'Repeated external card/ACH payments on the same account'
        : 'Completed external card/ACH payment';

  return (
    <Tooltip title={tooltip} arrow>
      <AccountBalanceIcon sx={{ width: iconSize, height: iconSize, color: '#5C6BC0' }} />
    </Tooltip>
  );
};

export default FinancialTrustBadge;
